/* Bilingual page toggle (EN/ES).
   The INITIAL language is set at parse time by the inline script in
   snippets/bilingual-base.liquid (body[data-lang]); this file wires up the
   toggle buttons and keeps every <lang-toggle> instance in sync.
   Content blocks are marked data-lang-block="en|es"; visibility is CSS-driven
   off body[data-lang], so with JS disabled the page shows English. */
(function () {
  // Several sections can each include this script; only the first copy runs.
  if (window.__utzLangToggle) return;
  window.__utzLangToggle = true;
  var KEY = 'utz-lang';

  /* Auto-translate. Theme UI the page doesn't own (filters, sort, product-card
     buttons) renders in the store's English locale, and the /es locale isn't
     published, so on bilingual pages those strings are swapped client-side
     from a dictionary:
       <script type="application/json" data-lang-dictionary
               data-lang-scope="CSS selector">{"strings": {...}, "patterns": [[regex, replacement], ...]}</script>
     The English original of every swapped text node and attribute is kept so
     the EN toggle restores it, and a MutationObserver re-applies Spanish after
     facets.js swaps the grid's HTML. */
  var ATTRS = ['aria-label', 'placeholder', 'title'];
  var dicts = null;
  var textOriginals = new WeakMap();
  var attrOriginals = new WeakMap();

  function loadDicts() {
    if (dicts) return dicts;
    dicts = [];
    document.querySelectorAll('script[type="application/json"][data-lang-dictionary]').forEach(function (el) {
      try {
        var d = JSON.parse(el.textContent);
        dicts.push({
          scope: el.getAttribute('data-lang-scope') || 'body',
          strings: d.strings || {},
          patterns: (d.patterns || []).map(function (p) { return [new RegExp(p[0]), p[1]]; })
        });
      } catch (e) { /* malformed dictionary: skip it */ }
    });
    return dicts;
  }

  function lookup(d, text) {
    var t = text.trim();
    if (!t) return null;
    var key = t.replace(/\s+/g, ' '); // \s also folds &nbsp;, which the theme uses in labels
    var hit = Object.prototype.hasOwnProperty.call(d.strings, key) ? d.strings[key] : null;
    for (var i = 0; hit === null && i < d.patterns.length; i++) {
      if (d.patterns[i][0].test(t)) hit = t.replace(d.patterns[i][0], d.patterns[i][1]);
    }
    return hit === null ? null : text.replace(t, hit);
  }

  function translateRoot(d, root, lang) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(function (node) {
      if (node.parentElement && node.parentElement.closest('script, style')) return;
      if (lang === 'es') {
        var source = textOriginals.has(node) ? textOriginals.get(node) : node.nodeValue;
        var es = lookup(d, source);
        if (es === null) return;
        if (!textOriginals.has(node)) textOriginals.set(node, node.nodeValue);
        if (node.nodeValue !== es) node.nodeValue = es;
      } else if (textOriginals.has(node)) {
        node.nodeValue = textOriginals.get(node);
        textOriginals.delete(node);
      }
    });
    var els = Array.prototype.slice.call(root.querySelectorAll('[aria-label], [placeholder], [title]'));
    els.forEach(function (el) {
      var saved = attrOriginals.get(el) || {};
      ATTRS.forEach(function (a) {
        if (!el.hasAttribute(a) && !(a in saved)) return;
        if (lang === 'es') {
          var source = a in saved ? saved[a] : el.getAttribute(a);
          var es = lookup(d, source);
          if (es === null) return;
          saved[a] = source;
          if (el.getAttribute(a) !== es) el.setAttribute(a, es);
        } else if (a in saved) {
          el.setAttribute(a, saved[a]);
          delete saved[a];
        }
      });
      attrOriginals.set(el, saved);
    });
  }

  var pending = null;
  var watching = false;
  function inScope(node) {
    var el = node.nodeType === 1 ? node : node.parentElement;
    if (!el) return false;
    return loadDicts().some(function (d) {
      return el.closest(d.scope) || (el.querySelector && el.querySelector(d.scope));
    });
  }
  function applyAuto(lang) {
    loadDicts().forEach(function (d) {
      document.querySelectorAll(d.scope).forEach(function (root) { translateRoot(d, root, lang); });
    });
    if (watching || !dicts.length) return;
    watching = true;
    // Re-translate after facets.js (or the editor) swaps markup in or around a
    // scope. A timer, not requestAnimationFrame: rAF pauses in background tabs.
    // Translating is idempotent, so our own writes settle in one extra pass.
    new MutationObserver(function (records) {
      if (pending || currentLang() !== 'es') return;
      if (!records.some(function (r) { return inScope(r.target); })) return;
      pending = setTimeout(function () { pending = null; applyAuto('es'); }, 30);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function currentLang() {
    // body[data-lang] is authoritative: it survives section re-renders and
    // URL rewrites (e.g. the theme's variant-change replaceState drops ?lang=).
    var cur = document.body && document.body.getAttribute('data-lang');
    if (cur === 'es' || cur === 'en') return cur;
    try {
      var p = new URLSearchParams(location.search).get('lang');
      if (p === 'es' || p === 'en') return p;
      var saved = localStorage.getItem(KEY);
      if (saved === 'es' || saved === 'en') return saved;
    } catch (e) { /* storage blocked */ }
    return (navigator.language || '').toLowerCase().indexOf('es') === 0 ? 'es' : 'en';
  }

  function syncButtons(root, lang) {
    (root || document).querySelectorAll('lang-toggle button[data-lang]').forEach(function (btn) {
      var active = btn.getAttribute('data-lang') === lang;
      btn.classList.toggle('lang-toggle__btn--active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function setLang(lang, updateUrl) {
    document.body.setAttribute('data-lang', lang);
    try { localStorage.setItem(KEY, lang); } catch (e) {}
    if (updateUrl) {
      try {
        var url = new URL(location.href);
        url.searchParams.set('lang', lang);
        history.replaceState(null, '', url);
      } catch (e) {}
    }
    syncButtons(document, lang);
    applyAuto(lang);
    document.dispatchEvent(new CustomEvent('lang:change', { detail: { lang: lang } }));
  }

  if (!customElements.get('lang-toggle')) {
    customElements.define('lang-toggle', class extends HTMLElement {
      connectedCallback() {
        // Elements can reconnect when the theme swaps section HTML —
        // guard the listener and re-sync buttons to the live language.
        if (!this.__wired) {
          this.__wired = true;
          this.addEventListener('click', function (e) {
            var btn = e.target.closest('button[data-lang]');
            if (btn) setLang(btn.getAttribute('data-lang'), true);
          });
        }
        syncButtons(this, currentLang());
      }
    });
  }

  function boot() { setLang(currentLang(), false); }
  // The theme editor replaces whole sections; re-run on the fresh markup.
  document.addEventListener('shopify:section:load', function () { applyAuto(currentLang()); });
  if (document.body) { boot(); } else {
    document.addEventListener('DOMContentLoaded', boot);
  }
})();
